module.exports = __webpack_public_path__ + "img/t1_ok.9cdb8d2c.png";